var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { classNames } from "../Util";
import { buttonStyles } from "../Button/Button";
import { ChevronDownIcon } from "@heroicons/react/20/solid";
var CollapseButton = function (_a) {
    var expandText = _a.expandText, collapseText = _a.collapseText, collapsed = _a.collapsed, setCollapsed = _a.setCollapsed;
    return (_jsx("button", __assign({ type: "button", title: collapsed ? expandText : collapseText, onClick: function () { return setCollapsed(!collapsed); }, className: classNames("p-1 w-7 h-7 rounded-full border text-gray-400 hover:text-gray-700 shadow-sm focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-transform", collapsed ? "-rotate-180" : "", buttonStyles.white.colorBorder, buttonStyles.white.bgColorHover) }, { children: _jsx(ChevronDownIcon, { className: "w-full h-full" }) })));
};
export default CollapseButton;
